// import { CommonModule } from "@angular/common";

import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from "@angular/core";
import { RouterModule } from "@angular/router";
// import { RouterModule } from "@angular/router";
import { BoardCard } from "@fry/boards/lib";
import { BookingModule } from "@fry/booking/app";
import { BookingsStore } from "@fry/booking/lib/bookings";
import { FryCommonModule } from "@fry/components/common";
import { InteractiveTableModule } from "@fry/components/common/list/interactive-table";
import { InteractiveTableOptions } from "@fry/components/common/list/interactive-table/interactive-table.component";
import { MaterialModule } from "@fry/components/material";
import { AuthService } from "@fry/lib/auth";
import { ListDefaults, TableService } from "@fry/lib/list";
import { UserService } from "@fry/lib/users";
import { UnboxedModule } from "@fry/ui";
import { tap } from "rxjs";
import { BookingTableCardOptions } from "./booking-table.card";

@Component({
    selector: "eas-booking-table-card",
    templateUrl: "./booking-table-card.view.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    RouterModule,
    FryCommonModule,
    UnboxedModule,
    BookingModule,
    InteractiveTableModule,
    MaterialModule
],
    providers: [
        TableService,
    ]
})
export class BookingTableCardViewComponent {

    card = input.required<BoardCard>();

    static key = "BookingTableCardComponent";

    private tableService = inject(TableService);
    private bookingsStore = inject(BookingsStore);
    private auth = inject(AuthService);
    private userService = inject(UserService, { optional: true});

    $searchModel = this.tableService.$mergedSearchModel;

    tableLoaded = signal<boolean>(false);

    $title = computed(() => this.card().options.title || $localize `Bookings`);
    $options = computed(() => this.card().options as BookingTableCardOptions);

    public tableComponentOptions: InteractiveTableOptions = {
        enableColumns: false,
        enableFilters: false,
        enablePagination: true,
        enableControls: false,
        itemSingleLabel: $localize `booking`,
        itemPluralLabel: $localize `bookings`,
    };

    ngOnInit() {
        this.initializeTable().subscribe({
            error: (error) => {
                console.error(error);
            }
        });
    }

    initializeTable() {
        const pageSize = this.$options().pageSize || 5;
        const defaults: ListDefaults = { listType: 'table', engine: 'es', pageSize: pageSize, hideFilters: ['__all__'] };
        defaults.fixedSearchModel = {
            filter: {
            },
            sort: { sort_on: 'createdDate', sort_order: 'desc' },
            select: ['user', 'bookingOption', 'createdDate', 'preview'],
            options: {
                includeFormFields: false
            },
            context: {
                filter: {},
                user: this.userService ? this.userService.user.doc.username : this.auth.current.username
            }
        }
        defaults.searchModel = this.$options().searchModel;
        return this.tableService.setupWith(this.bookingsStore, defaults, 'general')
            .pipe(tap(() => this.tableLoaded.set(true)));
    }
}
